export const TASK_TYPE_LABELS: Record<string, string> = {
  LOADING_PHOTO: 'Фото погрузки',
  LOADING_DOCUMENTS_UPLOAD: 'Загрузить документы погрузки',
  UNLOADING_PHOTO: 'Фото выгрузки',
  UNLOADING_DOCUMENTS_UPLOAD: 'Загрузить документы выгрузки',
  TN_ORIGINAL_MISSING: 'Нет оригиналов ТН',
  CARRIER_INVOICE_MISSING: 'Нет счета от перевозчика',
  CARRIER_INVOICE_CONFIRM: 'Подтвердить счет перевозчика',
  UPD_UPLOAD: 'Загрузить УПД',
  UPD_CONFIRM: 'Подтвердить УПД',
  CLIENT_DOCS_SENT: 'Документы отправлены клиенту',
  ORIGINALS_SENT: 'Оригиналы отправлены',
  CLIENT_DOCS_RECEIVED: 'Клиент получил документы',
  INVOICE_EXPECTED: 'Ожидается счет',
  PAYMENT_EXPECTED: 'Ожидается оплата',
  EXPENSE_CONFIRMATION: 'Подтвердить расходы по маршруту',
  CREATE_CLIENT_INVOICE: 'Создать счет клиенту',
  CONFIRM_INVOICE_SENT: 'Подтвердить отправку счета',
  UPLOAD_LOADING_DOCS: 'Загрузить документы погрузки',
  UPLOAD_UNLOADING_DOCS: 'Загрузить документы выгрузки',
  UPLOAD_UPD: 'Загрузить УПД',
  CONFIRM_UPD_SENT: 'Подтвердить отправку УПД',
  FORM_CLOSING_PACKAGE: 'Сформировать комплект закрывающих документов',
  SEND_SCANS_TO_CLIENT: 'Отправить сканы комплекта клиенту',
  SEND_CLOSING_PACKAGE_SCANS: 'Отправить сканы комплекта клиенту',
  WAIT_CLIENT_APPROVAL: 'Ожидание согласования комплекта клиентом',
  REVISE_CLOSING_PACKAGE: 'Доработать комплект закрывающих документов',
  PREPARE_ORIGINALS: 'Подготовить оригиналы комплекта',
  SEND_ORIGINALS: 'Отправить оригиналы комплекта клиенту',
  SEND_CLOSING_PACKAGE_ORIGINALS: 'Отправить оригиналы комплекта клиенту',
  CONFIRM_CLIENT_RECEIPT: 'Подтвердить получение оригиналов комплекта',
  SEND_VIA_EDO: 'Отправить документы через ЭДО',
  CONFIRM_EDO_RECEIPT: 'Подтвердить получение документов по ЭДО',
};

export const TASK_TYPE_SEVERITY: Record<string, 'critical' | 'warning' | 'info'> = {
  LOADING_PHOTO: 'warning',
  LOADING_DOCUMENTS_UPLOAD: 'warning',
  UNLOADING_PHOTO: 'warning',
  UNLOADING_DOCUMENTS_UPLOAD: 'warning',
  TN_ORIGINAL_MISSING: 'critical',
  CARRIER_INVOICE_MISSING: 'critical',
  CARRIER_INVOICE_CONFIRM: 'warning',
  UPD_UPLOAD: 'warning',
  UPD_CONFIRM: 'warning',
  CLIENT_DOCS_SENT: 'info',
  ORIGINALS_SENT: 'warning',
  CLIENT_DOCS_RECEIVED: 'info',
  INVOICE_EXPECTED: 'warning',
  PAYMENT_EXPECTED: 'critical',
  EXPENSE_CONFIRMATION: 'warning',
  CREATE_CLIENT_INVOICE: 'warning',
  CONFIRM_INVOICE_SENT: 'warning',
  UPLOAD_LOADING_DOCS: 'info',
  UPLOAD_UNLOADING_DOCS: 'info',
  UPLOAD_UPD: 'info',
  CONFIRM_UPD_SENT: 'warning',
  FORM_CLOSING_PACKAGE: 'warning',
  SEND_SCANS_TO_CLIENT: 'warning',
  SEND_CLOSING_PACKAGE_SCANS: 'warning',
  WAIT_CLIENT_APPROVAL: 'info',
  REVISE_CLOSING_PACKAGE: 'critical',
  PREPARE_ORIGINALS: 'warning',
  SEND_ORIGINALS: 'warning',
  SEND_CLOSING_PACKAGE_ORIGINALS: 'warning',
  CONFIRM_CLIENT_RECEIPT: 'warning',
  SEND_VIA_EDO: 'warning',
  CONFIRM_EDO_RECEIPT: 'warning',
};

